module.exports = __webpack_public_path__ + "img/icon_button_powietrze.0ac84997.svg";